export default __webpack_public_path__ + "static/roof-a169a08044440d87f41d70849d8682a3.gif";